/**
 * @name PaymentsController
 * @description Controller for recording appointment payments
 * @param {type} $uibModalInstance Description
 * @param {service} Messages Description
 * @param {service} Payments Description
 * @param {resolve} appointment The resolved appt from the appt controller
 * @param {resolve} project The resolved project from the appt controller
 * @param {library} moment Description
 * @param {service} AlertMessages Description
 * @param {library} _ Description
 * @param {service} Session The Session service
 */
function PaymentsController(
  $uibModalInstance,
  Messages,
  Payments,
  appointment,
  project,
  moment,
  AlertMessages,
  _,
  Session
) {
  let vm = this;

  vm.$onInit = function() {
    // Public Methods
    vm.savePayment = savePayment;
    vm.voidPayment = voidPayment;
    vm.toggleIsDeposit = toggleIsDeposit;
    vm.session = Session;

    // Public Variables
    vm.isAddPaymentCollapsed = true;
    vm.appointment = appointment;
    vm.project = project;
    vm.message = {
      cid: vm.appointment.conversations,
      content: null,
      private: false
    };
    vm.paymentData = {
      appointment_id: vm.appointment.id,
      collector_id: vm.project.collector.id,
      payment_datetime: moment().toDate(),
      is_deposit: false,
      is_tip: false
    };

    // If the appointment is completed, set is_tip to true
    if (vm.appointment.current_status === 70) {
      vm.paymentData.is_tip = true;
    }
    vm.canEdit = determineEditStatus();
    vm.canOnlyAddTips = determineOnlyTipPaymentStatus();
  };

  /**
   * @name determineEditStatus
   * @description Function to determine if payments are editable. If the
   * appointment is in any status other than unconfirmed or confirmed, you
   * should not be able to edit/add payments.
   * @return {boolean} Returns true of false based on the appointment status
   */
  function determineEditStatus() {
    if (vm.appointment.current_status === 40 ||
    vm.appointment.current_status === 50) {
      return true;
    }
    return false;
  }

  /**
   * @name determineOnlyTipPaymentStatus
   * @description Function to determine if only tip payments are acceptable.
   * If the appointment is in any status other than completed, you should not be
   * able to add regular payments.
   * @return {boolean} Returns true of false based on the appointment status
   */
  function determineOnlyTipPaymentStatus() {
    if (vm.appointment.current_status === 70) {
      return true;
    }
    return false;
  }

  // Get Payment Types
  Payments.getTypes()
  .then(function(paymentTypes) {
    vm.paymentTypes = paymentTypes;
  });

  /**
   * @name submit
   * @description Submit a Payment
   */
  function savePayment() {
    Payments.create(vm.paymentData)
    .then(function(allPayments) {
      vm.appointment.payments = allPayments;
      Payments.process(vm.appointment).then(function(parsedPayments) {
        vm.parsedPayments = parsedPayments;
        vm.appointment.paymentData = parsedPayments;
        vm.isAddPaymentCollapsed = true;

        // Send a Message if one exists
        if (vm.message.content !== null &&
        vm.message.content.replace(/\s/g, '').length) {
          Messages.create(vm.message).then(function(message) {
            vm.messageAdded = message;
            vm.message.content = null;
            vm.message.private = false;
          }, function(error) {
            AlertMessages.add({
              msg: 'There was a problem sending the message. Our server responded with: ' +
                error,
              type: 'warning'});
          });
        }

        // Reset the payment form
        resetPaymentForm();
      });
    });
  }

  /**
  * @description Void payment
  * @param {object} payment Unknown
  */
  function voidPayment(payment) {
    payment.status = 2; // 2 === void status
    Payments.update(payment).then(function(allPayments) {
      vm.appointment.payments = allPayments;
      Payments.process(vm.appointment).then(function(parsedPayments) {
        vm.parsedPayments = parsedPayments;
        vm.appointment.paymentData = parsedPayments;
      });
    });
  }

  /**
   * @name toggleIsDeposit
   * @description Function to save the payment with the is_deposit field set to
   * the opposite of what the field is currently
   * @param {type} payment The payment to change
   */
  function toggleIsDeposit(payment) {
    payment.is_deposit = payment.is_deposit ? false : true;
    Payments.update(payment).then(function(allPayments) {
      vm.appointment.payments = allPayments;
      Payments.process(vm.appointment).then(function(parsedPayments) {
        vm.parsedPayments = parsedPayments;
        vm.appointment.paymentData = parsedPayments;
      });
    });
  }

  /**
   * @name resetPaymentForm
   * @description Function to reset the form back to default
   */
  function resetPaymentForm() {
    vm.paymentData.is_deposit = false;
    vm.paymentData.payment_datetime = moment().toDate();
    vm.paymentData.payment_type = null;
    vm.paymentData.amount = null;
    vm.paymentData.receipt = null;
    vm.addPaymentForm.$setPristine();
  }

  // Close and send back all payments
  vm.close = function() {
    let parsedPayments = vm.parsedPayments;
    let message = vm.messageAdded;
    if (!_.isUndefined(vm.parsedPayments)) {
      $uibModalInstance.close({parsedPayments, message});
    } else {
      $uibModalInstance.dismiss();
    }
  };
}

angular
  .module('inkfinder')
  .controller('PaymentsController', PaymentsController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/payments/payments.controller.js